export const engagementEmailTemplatesTerritories = "/engagement/email_templates/territories";
